

import { Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import useSWR from 'swr';

import { PageStyle } from '../../../../assets/styles/custom.styles';
import getErrorMessage from '../../../../assets/utils/getErrorMessage';
import CustomerList from '../../../../components/partner/customer/customerList';

export interface TenantObject {
  admins: Array<string>;
  countryNames: Array<string>;
  name: string;
  slug: string;
  numberOfUsers: number;
  status: string;
}

export interface TenantFromApiObject {
  id: string;
  admins: string[],
  country_names: string[],
  name: string,
  slug: string,
  number_of_users: number,
  status: string,
}

const transformTenantData = (data: TenantFromApiObject[]) => {
  const tenants: TenantObject[] = data.map(({ admins, country_names, name, slug, number_of_users, status }) => ({
    admins, 
    name,
    slug,
    status,
    countryNames: country_names, 
    numberOfUsers: number_of_users,
  }
  ));
  return tenants;
};


const CustomerPage = () => {
  const [customerList, setCustomerList] = useState<Array<TenantObject>>([]);

  const { data, isLoading, error } = useSWR('/confide/tenants', { revalidateOnFocus: false });

  useEffect(() => {
    if (!isLoading && !error) {
      const transformedData = transformTenantData(data);
      setCustomerList(transformedData);
    }
  }, [data, isLoading, error]);

  return (
    <Stack sx={PageStyle.container}>
      <CustomerList 
        isLoading={isLoading}
        isError={error}
        errorText={getErrorMessage(error)}
        list={customerList}
      />
    </Stack>
  );
};

export default CustomerPage;